import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Typography, CircularProgress, Divider, Breadcrumbs } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseHandler } from '../../../hooks/useResponseHandler';
import { getContratoDetailStore, setContratoRedux } from 'store/contratos';

export const DetailContrato = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<any>();
    const { ResponseComponents, handleResponse } = useResponseHandler();
    const [loading, setLoading] = useState(true);

    const { contrato } = useSelector((state: any) => state.contratos);

    useEffect(() => {
        if (id) {
            getDetail(id);
        }
    }, [id]); // eslint-disable-line

    const getDetail = async (contratoId: string) => {
        setLoading(true);
        const response = await dispatch(getContratoDetailStore(contratoId));
        await handleResponse(response, 'Obtener contrato', false);
        setLoading(false);
    };

    return (
        <Box sx={{ width: '100%' }}>
            {ResponseComponents}
            
            <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Detalle del Contrato</Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
                <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Talento Humano</Typography>
                <Link color="inherit" to="/talento-humano/contratos" style={{ textDecoration: 'none' }}>
                    Gestión de Contratos
                </Link>
                <Typography color="textPrimary">Detalle del Contrato</Typography>
            </Breadcrumbs>
            
            <Divider sx={{ marginBottom: 3 }}/>
            
            <Card sx={{ 
                p: 3, 
                borderRadius: 3, 
                boxShadow: '0px 12px 24px -4px rgba(105, 108, 255, 0.15)',
                border: 'none'
            }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Box>
                                <Typography variant="h6" color="textSecondary" gutterBottom>
                                    Tipo de Contrato
                                </Typography> 
                                  <Typography variant="h5" fontWeight={700} > 
                                     {contrato?.name}
                                </Typography>
                            </Box> 
                            <Box>
                                <Typography 
                                    variant="caption" 
                                    sx={{ 
                                        px: 2, 
                                        py: 1, 
                                        borderRadius: 1, 
                                        bgcolor: contrato?.status ? 'rgba(84, 214, 44, 0.16)' : 'rgba(255, 72, 66, 0.16)', 
                                        color: contrato?.status ? '#229A16' : '#B72136',
                                        fontWeight: 700
                                    }}
                                >
                                    {contrato?.status ? 'ACTIVO' : 'INACTIVO'}
                                </Typography>
                            </Box>
                        </Box>
                        
                        <Divider sx={{ my: 3 }} />
                        
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                            Contenido del Contrato:
                        </Typography>
                        
                        <Box 
                            sx={{ 
                                mt: 2, 
                                p: 3, 
                                border: '1px solid #E5E7EB', 
                                borderRadius: 2,
                                bgcolor: '#FAFAFA',
                                minHeight: 300
                            }}
                            className="ql-editor"
                            dangerouslySetInnerHTML={{ __html: contrato?.content || '<em>Sin contenido</em>' }}
                        />
                        
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                            <Button
                                component={Link}
                                to="/talento-humano/contratos"
                                color="inherit"
                                variant="outlined"
                                sx={{ borderRadius: 2, textTransform: 'none' }}
                            >
                                Volver
                            </Button>
                        </Box>
                    </Box>
                )}
            </Card>
        </Box>
    );
};
